import { styled } from 'styled-components';

import { RichDetails } from '#/components/RichDetails/RichDetails';
import {
  richDetailsStateClosedClass,
  richDetailsStateOpenClass,
} from '#/components/RichDetails/richDetailsClasses';
import {
  detailsBrandBlueWhenOpenVar,
  detailsCalloutGreyWhenOpenVar,
  detailsOneWhenClosedMinusOneWhenOpenVar,
  detailsOneWhenClosedZeroWhenOpenVar,
  detailsSelectionGreyWhenOpenVar,
} from '#/components/RichDetails/richDetailsCssVariables';
import { colors, cssBreakpoints, transition } from '#/theme/theme';

/**
 * Do not add `position: relative` to the details.
 *
 * In some cases, such as the mobile DropdownFoldMenu, we need the menu to align
 * with the parent container, not the `details` tag
 *
 * Instead, add `position: relative` to the desired wrapping element
 */
export const DropdownRichDetails = styled(RichDetails)`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    position: relative;
  }

  display: inline-flex;

  ${detailsOneWhenClosedMinusOneWhenOpenVar}: 1;
  ${detailsOneWhenClosedZeroWhenOpenVar}: 1;

  &[open] {
    z-index: 200;
    ${detailsOneWhenClosedMinusOneWhenOpenVar}: -1;
    ${detailsOneWhenClosedZeroWhenOpenVar}: 0;
    ${detailsBrandBlueWhenOpenVar}: ${colors.brandBlue};
    ${detailsCalloutGreyWhenOpenVar}: ${colors.calloutGrey};
    ${detailsSelectionGreyWhenOpenVar}: ${colors.selectionGrey};
  }

  &.${richDetailsStateOpenClass} {
    menu {
      transition: ${transition};
      transition-property: transform;
    }
  }

  &.${richDetailsStateClosedClass} {
    menu {
      visibility: hidden;

      @media all and (max-width: ${cssBreakpoints.mdDown}) {
        transform: translateY(-10%);
      }

      @media all and (min-width: ${cssBreakpoints.mdUp}) {
        transform: translateY(-10px);
      }
    }
  }
`;

export const DropdownSummary = styled.summary`
  list-style: '';
  position: relative;
  z-index: 100;

  &::-webkit-details-marker /* Safari < 18.4 */ {
    display: none;
  }
`;
